<template>
    <div style="display: flex; flex-direction: row; justify-content: flex-end; align-items: center;" class="q-mt-sm">
        <QBtn v-if="params.data.Type == 'Project'"
              size="sm" flat round dense
              class="q-mr-sm"
              color="blue-grey-4"
              icon="mdi-cog-outline"
              @click.stop.prevent="openConfig"
        />
        <QBtn v-if="menuItems"
               color="primary"
               size="sm"
               flat
               round
               dense
               icon="mdi-dots-vertical"
               @click.stop.prevent
               @mousedown.stop.prevent>
            <QMenu anchor="bottom end" self="top end" auto-close>
                <QList dense class="q-pa-none">
                    <QItem v-for="(item, index) in menuItems"
                           :key="index"
                           :clickable="!rowLocked"
                           :disable="rowLocked"
                           :style="{ borderTop: index > 0 && item.title.startsWith('Delete') ? '1px solid gray' : null }"
                           @click.stop.prevent="menuClick($event, item)">
                        <QItemSection>
                            <QItemLabel :class="{ 'text-grey-5': rowLocked }">{{ item.title }}</QItemLabel>
                        </QItemSection>
                    </QItem>
                </QList>
            </QMenu>
        </QBtn>
    </div>
</template>

<script>
    import { QIcon, QBtn, QMenu, QList, QItem, QItemSection, QItemLabel, QTooltip } from 'quasar';

    function ancestorProjectId(node) {
        let walk = node;
        while (walk?.data && walk.data.Type != 'Project' && walk.parent)
            walk = walk.parent;
        if (walk?.data?.Type == 'Project')
            return walk.data.ID;
        return null;
    }

    export default {
        name: 'flow-v2-folder-menu',
        components: {
            QIcon, QBtn, QMenu, QList, QItem, QItemSection, QItemLabel, QTooltip,
        },
        emits: [
            'open-config',
            'add-folder',
            'add-project',
            'add-class',
            'add-flow',
            'add-api',
            'delete-folder',
            'delete-project',
            'delete-class',
            'delete',
            'save-recipe',
        ],
        data() {
            return {
                folderitems: [
                    { title: 'Create Folder' },
                    { title: 'Create Project' },
                    { title: 'Delete Folder' },
                ],
                projectitems: [
                    { title: 'Add Flowchart' },
                    { title: 'Add Class' },
                    { title: 'Delete Project' },
                ],
                classitems: [
                    { title: 'Add Flowchart' },
                    { title: 'Add API' },
                    { title: 'Delete Class' },
                ],
            }
        },
        props: {
        },
        computed: {
            rowLocked() {
                const ids = this.params?.lockedProjectIds;
                if (!ids || !ids.length)
                    return false;
                const data = this.params?.data;
                if (!data)
                    return false;
                const projectId = data.Type == 'Project'
                    ? data.ID
                    : ancestorProjectId(this.params?.node);
                if (!projectId)
                    return false;
                return ids.some(id => id == projectId);
            },
            methodMenuItems() {
                const items = [];
                if (this.params?.askAiEnabled)
                    items.push({ title: 'Save recipe' });
                items.push({ title: 'Delete' });
                return items;
            },
            menuItems() {
                switch (this.params.data.Type) {
                    case 'Folder': return this.folderitems;
                    case 'Project': return this.projectitems;
                    case 'Class': return this.classitems;
                    case 'APIHeader':
                    case 'FlowHeader':
                        return this.methodMenuItems;
                    default:
                        return null;
                }
            }
        },
        methods: {
            openConfig(e) {
                e.preventDefault();
                this.params.emit('open-config', this.params.data);
            },
            menuClick(e, item) {
                e.preventDefault();
                if (this.rowLocked)
                    return;
                switch (item.title) {
                    case 'Create Folder': this.params.emit('add-folder', this.params.data); break;
                    case 'Create Project': this.params.emit('add-project', this.params.data); break;
                    case 'Add Class': this.params.emit('add-class', this.params.data); break;
                    case 'Add Flowchart': this.params.emit('add-flow', this.params.data); break;
                    case 'Add API': this.params.emit('add-api', this.params.data); break;
                    case 'Delete Folder': this.params.emit('delete-folder', this.params.data); break;
                    case 'Delete Project': this.params.emit('delete-project', this.params.data); break;
                    case 'Delete Class': this.params.emit('delete-class', this.params.data); break;
                    case 'Delete': this.params.emit('delete', this.params.data); break;
                    case 'Save recipe': this.params.emit('save-recipe', this.params.data); break;
                }
            },
        }
    };
</script>
